import { render, staticRenderFns } from "./btn-secondary2.vue?vue&type=template&id=0bc7ab8e&scoped=true&"
import script from "./btn-secondary2.vue?vue&type=script&lang=js&"
export * from "./btn-secondary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7ab8e",
  null
  
)

export default component.exports